module.exports = __webpack_public_path__ + "img/l.e58cee58.jpg";